import * as React from 'react';

import { Badge } from '@rematter/ui-web';
import { cn } from '@rematter/ui-web/lib';

interface NotificationBadgeProps {
  count: number;
  className?: string;
  maxCount?: number;
}

/**
 * A red notification badge that displays an unread count.
 * Shows nothing when count is 0, and "99+" when count exceeds maxCount.
 */
export const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  count,
  className,
  maxCount = 99,
}) => {
  // Don't render anything if count is 0 or negative
  if (count <= 0) return null;

  // Format the display count
  const displayCount = count > maxCount ? `${maxCount}+` : count.toString();

  return (
    <Badge
      size="xs"
      className={cn(
        '@NotificationBadge',
        // Position absolutely in top-right corner
        'absolute -top-1 -right-1',
        // Size and shape
        'flex h-5 min-w-[1.25rem] items-center justify-center',
        // Colors - red background with white text
        'border-2 border-white bg-failure/50 text-white',
        // Typography
        'text-xs font-semibold',
        // Ensure it's above other elements
        'z-10',
        className,
      )}
    >
      {displayCount}
    </Badge>
  );
};
